import { RouteObject } from 'react-router-dom';
import { Page404 } from 'src/error-page';
import { EnterpriseProjectsProvider } from 'src/contexts/enterprise-projects-context';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const FindsView = lazyConReintento(() => import('./index'));
const CreateRequestsWizard = lazyConReintento(() => import('./create-requests'));
const ServiceRequestDetailsView = lazyConReintento(() => import('./active-tab/service-request-details'));

const findsRoutes: RouteObject[] = [
  {
    path: 'finds/new-request',
    element: diferida(
      <EnterpriseProjectsProvider>
        <CreateRequestsWizard />
      </EnterpriseProjectsProvider>
    )
  },
  {
    path: 'finds',
    element: diferida(<FindsView />)
  },
  {
    path: 'finds/active/:id/:matchid?',
    element: diferida(<ServiceRequestDetailsView />)
  },
  {
    path: '*',
    element: <Page404 />
  }
];

export default findsRoutes;
